import SparkMD5 from "spark-md5";
import axios from "axios";
import wx from "weixin-js-sdk";

var tools = {
  api: {
    matchList: "/match/newMatchList", // 首页赛事列表
    matchInfoList: "/api/information", // 首页赛事资讯列表
    matchInfoDetail: "/api/informationDetail", // 赛事资讯详情
    hotKeywordList: "/api/hotList", // 搜索热门关键词列表
    homeAwardList: "/api/prizesList", // 首页赛事获奖公布列表
    addVisit: "/match/add_visit", // 赛事资讯页点击统计

    isTeamMember: "/team/isTeamMember", // 判断战队信息
    teamInfo: "/team/teamInfo", // 战队信息
    teamList: "/team/teamList", // 战队信息
    contributeTeam: "/team/join_single", // 战队投稿和内容修改
    getWork: "match/get_work", // 查看作品
    delGroupWorks: "/team/delmyworks", //删除帖子
    teamWorksList: "/team/h5List",  // 获取战队个人作品列表
  },
  getMd5(file) {
    var p = new Promise((resolve, reject) => {
      var fileReader = new FileReader();
      var dataFile = file;
      var spark = new SparkMD5(); //创建md5对象（基于SparkMD5）
      if (dataFile.size > 1024 * 1024 * 20) {
        var data1 = dataFile.slice(0, 1024 * 1024 * 20); //将文件进行分块 file.slice(start,length)
        fileReader.readAsBinaryString(data1); //将文件读取为二进制码
      } else {
        fileReader.readAsBinaryString(dataFile);
      }
      //文件读取完毕之后的处理
      fileReader.onload = function(e) {
        spark.appendBinary(e.target.result);
        var md5 = spark.end();
        if (md5) {
          resolve(md5);
        } else {
          reject();
        }
      };
    });
    return p;
  },
  callbackOss(file, callback) {
    let formData = new FormData();
    formData.append("key", file.key);
    formData.append("policy", file.policy);
    formData.append("OSSAccessKeyId", file.OSSAccessKeyId);
    formData.append("success_action_status", "200"); // 让服务端返回200,不然，默认会返回204
    formData.append("callback", "");
    formData.append("signature", file.signature);
    formData.append("file", file);

    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    var uploadUrl = file.url;
    if (process.env.NODE_ENV == "development") {
      uploadUrl = "/aly";
    }
    //正式包file.url
    axios.post(uploadUrl, formData, config).then(function(result) {
      var imgPath = "";
      if (result.status === 200) {
        imgPath = file.url + "/" + file.key;
      }
      if (callback) {
        callback(imgPath);
      }
    });
  },
  callbackOssVideo(file, progress, callback) {
    let formData = new FormData();
    formData.append("key", file.key);
    formData.append("policy", file.policy);
    formData.append("OSSAccessKeyId", file.OSSAccessKeyId);
    formData.append("success_action_status", "200"); // 让服务端返回200,不然，默认会返回204
    formData.append("callback", "");
    formData.append("signature", file.signature);
    formData.append("file", file);

    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        // 开启上传，则隐藏上传按钮；显示上传进度
        var complete = Math.min(
          ((progressEvent.loaded / progressEvent.total) * 100) | 0,
          99
        );
        // 通过回调函数传出上传进度
        progress(complete);
      },
    };
    //正式包file.url
    axios.post(file.url, formData, config).then(function(result) {
      var imgPath = "";
      if (result.status === 200) {
        imgPath = file.url + "/" + file.key;
      }
      if (callback) {
        callback(imgPath);
      }
    });
  },
  uploadaly(file) {
    var c = new Promise((resolve, reject) => {
      var that = this;
      that.getMd5(file).then((md5) => {
        file.md5 = md5;
        axios
          .post("/match/params", { name: file.name, md5: md5 })
          .then((res) => {
            if (res.status == 200) {
              var obj = res.data.data;
              file.key = obj.key;
              file.policy = obj.policy;
              file.OSSAccessKeyId = obj.id;
              file.signature = obj.signature;
              file.url = obj.url;
              that.callbackOss(file, function(res) {
                if (res) {
                  resolve(res);
                } else {
                  reject(false);
                }
              });
            } else {
              reject(false);
            }
          });
      });
    });
    return c;
  },
  hasImgType(arr, str) {
    for (var i = 0; i < arr.length; i++) {
      if (str.indexOf(arr[i]) != -1) {
        break;
      }
    }
    if (i < arr.length) {
      return true;
    } else {
      return false;
    }
  },
  getMatchDetail(obj) {
    var that = this;
    var d = new Promise((resolve) => {
      var data = { custom_fields: {}, gourp_limit: {}, match_limit: {} };
      that.getDetail(obj).then((res) => {
        data.custom_fields = res.custom_fields;
        data.match_limit = res;
        data.gourp_limit = that.return_group(res.match_group, obj.group);
        resolve(data);
      });
    });
    return d;
  },
  getWorksDetail(obj) {
    var d = new Promise((resolve, reject) => {
      axios.post("/match/getWorksDetail", obj).then((res) => {
        if (res.status == 200) {
          resolve(res.data.data);
        } else {
          reject(res);
        }
      });
    });
    return d;
  },
  getDetail(obj) {
    var that = this;
    var d = new Promise((resolve) => {
      that.detail_cache(obj, false).then((res) => {
        resolve(res);
      });
    });
    return d;
  },
  getAreaList() {
    var d = new Promise((resolve, reject) => {
      axios.post("/match/getAreaList").then((res) => {
        if (res.status == 200) {
          resolve(res.data.data);
        } else {
          reject(res);
        }
      });
    });
    return d;
  },
  getAreas() {
    var d = new Promise((resolve, reject) => {
      var list = sessionStorage.getItem("match_areas");
      if (!list || list == "undefined") {
        axios.post("/match/areas").then((res) => {
          if (res.status == 200) {
            sessionStorage.setItem(
              "match_areas",
              JSON.stringify(res.data.data)
            );
            resolve(res.data.data);
          } else {
            reject(res);
          }
        });
      } else {
        list = JSON.parse(list);
        resolve(list);
      }
    });
    return d;
  },
  getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); //匹配目标参数
    if (r != null) return decodeURI(r[2]);
    return null; //返回参数值
  },
  return_group(arr, gid) {
    for (var i = 0; i < arr.length; i++) {
      if (gid == arr[i].gid) {
        return arr[i];
      }
    }
    return false;
  },
  detail_cache(obj, init) {
    var c = new Promise((resolve, reject) => {
      var cache_name = "match_detail" + obj.id;
      var detail = sessionStorage.getItem(cache_name);
      if (init || !detail || detail == "undefined") {
        axios.post("/match/detail", obj).then((res) => {
          if (res.status == 200) {
            sessionStorage.setItem(cache_name, JSON.stringify(res.data.data));
            resolve(res.data.data);
          } else {
            reject(res);
          }
        });
      } else {
        detail = JSON.parse(detail);
        resolve(detail);
      }
    });
    return c;
  },
  infoDetail_cache(obj, init) {
    var c = new Promise((resolve, reject) => {
      var cache_name = "match_infoDetail" + obj.id;
      var detail = sessionStorage.getItem(cache_name);
      if (init || !detail || detail == "undefined") {
        axios.post(this.api.matchInfoDetail, obj).then((res) => {
          if (res.status == 200) {
            sessionStorage.setItem(cache_name, JSON.stringify(res.data.data));
            resolve(res.data.data);
          } else {
            reject(res);
          }
        });
      } else {
        detail = JSON.parse(detail);
        resolve(detail);
      }
    });
    return c;
  },
  // 是否app打开
  openInWebview() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      // 微信浏览器判断
      return false;
    } else if (ua.match(/QQ/i) == "qq") {
      // QQ浏览器判断
      return false;
    } else if (ua.match(/WeiBo/i) == "weibo") {
      return false;
    } else {
      if (ua.match(/Android/i) != null) {
        return ua.match(/browser/i) == null;
      } else if (ua.match(/iPhone/i) != null) {
        return ua.match(/safari/i) == null;
      } else {
        return ua.match(/macintosh/i) == null && ua.match(/windows/i) == null;
      }
    }
  },
  ajax_error(err) {
    console.log(err);
    /* eslint-disable */
    // 调用passport
    passportLogin.login();
    /* eslint-enable */
    //location.href = this.loginUrl;
  },
  sessionSetItem(status, value) {
    return sessionStorage.setItem("checkVal" + status, JSON.stringify(value));
  },
  sessionRemoveItem(status) {
    return sessionStorage.removeItem("checkVal" + status);
  },
  sessionRemoveAll() {
    sessionStorage.removeItem("checkValmaster");
    sessionStorage.removeItem("checkValai");
    sessionStorage.removeItem("checkValissue");
    return;
  },
  sessionGetItem(status) {
    return JSON.parse(sessionStorage.getItem("checkVal" + status)) || [];
  },
  wx_share_init(data) {
    if (wx != "undefined") {
      if (typeof data == "undefined") {
        data = { url: window.location.href };
      }
      axios.post("/match/get_wx_config", data).then((res) => {
        var signPackage = res.data.data["signPackage"];
        var share_config = res.data.data["share_config"];
        // console.log(signPackage);
        wx.config({
          debug: false,
          appId: signPackage.appId,
          timestamp: signPackage.timestamp,
          nonceStr: signPackage.nonceStr,
          signature: signPackage.signature,
          jsApiList: [
            "checkJsApi",
            "onMenuShareQQ",
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "openLocation",
          ],
        });
        wx.ready(function() {
          wx.onMenuShareAppMessage({
            title: share_config.title,
            desc: share_config.desc,
            link: share_config.link,
            imgUrl: share_config.imgUrl,
            type: "", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function() {},
          });

          wx.onMenuShareTimeline({
            title: share_config.title,
            desc: share_config.desc,
            link: share_config.link,
            imgUrl: share_config.imgUrl,
            success: function() {},
          });
          wx.onMenuShareQQ({
            title: share_config.title,
            desc: share_config.desc,
            link: share_config.link,
            imgUrl: share_config.imgUrl,
            success: function() {},
            cancel: function() {},
          });
          wx.error(function(res) {
            console.log("wx.error:" + res.errMsg);
          });
        });
      });
    }
  },
};
export default tools;
